import type { PollingOptions } from './usePolling.types';

export const TEST_ENDPOINT = '*/test-endpoint';

export const DEFAULT_POLLING_OPTIONS: PollingOptions = {
  delayUnit: 250,
  maxTime: 3000,
  maxAttemptsBeforeDelay: 0,
};
